import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface OwnerSettingsContextType {
  disabledOwners: string[];
  toggleOwner: (owner: string) => void;
  setDisabledOwners: React.Dispatch<React.SetStateAction<string[]>>;
}

const OwnerSettingsContext = createContext<OwnerSettingsContextType | null>(null);

export function OwnerSettingsProvider({ children }: { children: ReactNode }) {
  const [disabledOwners, setDisabledOwners] = useState<string[]>(() => {
    const saved = localStorage.getItem('disabledOwners');
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem('disabledOwners', JSON.stringify(disabledOwners));
  }, [disabledOwners]);

  const toggleOwner = (owner: string) => {
    setDisabledOwners(prev =>
      prev.includes(owner) ? prev.filter(o => o !== owner) : [...prev, owner]
    );
  };

  return (
    <OwnerSettingsContext.Provider value={{ disabledOwners, toggleOwner, setDisabledOwners }}>
      {children}
    </OwnerSettingsContext.Provider>
  );
}

export function useOwnerSettings() {
  const context = useContext(OwnerSettingsContext);
  if (!context) throw new Error('useOwnerSettings must be used within OwnerSettingsProvider');
  return context;
}
